<template>
  <b-modal v-model="isActive" has-modal-card class="data-completion">
    <form @submit.prevent="updateData" class="enable-select-text">
      <div class="modal-card data-completion-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-success">Data Completion</p>
          <b-button slot="right" type="is-primary" @click="addStream">
            Add Stream
          </b-button>
        </header>
        <section class="modal-card-body">
          <div v-for="(stream, index) in streams" :key="index">
            <div class="columns ">
              <b-field class="column is-9">
                <b-select
                  expanded
                  name="stream"
                  v-model="stream.value"
                  placeholder="Please Select a Stream"
                  @input="checkStream($event, index)"
                  required
                >
                  <option
                    v-for="(option, index) in streamsDropdown"
                    :value="option.name"
                    :key="index"
                  >
                    {{ option.name }}
                  </option>
                </b-select>
              </b-field>
              <div class="column is-2 delete-stream-button">
                <a
                  v-if="index !== 0"
                  slot="right"
                  class="delete-field"
                  @click="deleteStream(index)"
                  ><b-icon icon="delete" type="is-danger"></b-icon
                ></a>
              </div>
            </div>

            <div class="data-completion-field">
              <b-field>
                <div
                  v-for="(field, index2) in stream.fields"
                  :key="index2"
                  class="columns"
                >
                  <b-field class="column is-3"
                    ><b-select
                      expanded
                      v-model="field.field_name"
                      placeholder="Please Select a Field"
                      required
                      @input="addFieldType($event, index, index2)"
                    >
                      <option
                        required
                        v-for="(option, index) in getStreamFields(
                          stream.value
                        ).filter(
                          o =>
                            o.field_name !== 'PRODUCT NUMBER' &&
                            o.field_name !== 'PRODUCT NAME'
                        )"
                        :value="option.product_data_column.trim()"
                        :key="index"
                      >
                        {{ option.field_name }}
                      </option>
                    </b-select></b-field
                  >
                  <b-field class="column is-3"
                    ><b-select
                      expanded
                      :disabled="!field.field_name"
                      v-model="field.operation"
                      placeholder="Please Select an Operation"
                      required
                    >
                      <option
                        required
                        v-for="(option, index) in operations"
                        :value="option.name.toLowerCase()"
                        :key="index"
                      >
                        {{ option.name }}
                      </option>
                    </b-select></b-field
                  >
                  <b-field
                    class="column is-3"
                    v-if="field.operation == 'value'"
                  >
                    <b-field v-if="isDateField(field.field_name, stream.value)">
                      <b-datepicker
                        v-model="field.value"
                        placeholder="Please select a Value"
                        icon="calendar-today"
                        trap-focus
                        required
                      ></b-datepicker>
                    </b-field>
                    <b-field
                      v-else-if="
                        isDropdownField(field.field_name, stream.value)
                      "
                    >
                      <b-select
                        placeholder="Please select a Value"
                        v-model="field.value"
                        required
                        v-if="
                          typeof getDropdownFieldValues(
                            field.field_name,
                            stream.value
                          )[0] == 'object'
                        "
                      >
                        <optgroup
                          v-for="(value, name, index) in getDropdownFieldValues(
                            field.field_name,
                            stream.value
                          )[0] || {}"
                          :key="index"
                          :label="name"
                        >
                          <option
                            v-for="(v, k) in value.filter(u => u != 'NA')"
                            :value="v"
                            :key="k"
                            >{{ v }}</option
                          ></optgroup
                        >
                      </b-select>
                      <b-select
                        expanded
                        v-model="field.value"
                        placeholder="Please select a Value"
                        required
                        v-else
                      >
                        <option
                          v-for="(value, index) in getDropdownFieldValues(
                            field.field_name,
                            stream.value
                          ).filter(u => u != 'NA')"
                          :value="value"
                          :key="index"
                        >
                          {{ value }}
                        </option>
                      </b-select>
                    </b-field>
                    <b-field v-else>
                      <b-input
                        required
                        v-model="field.value"
                        placeholder="Value"
                      >
                      </b-input>
                    </b-field>
                  </b-field>
                  <b-field class="column is-2">
                    <a
                      class="delete-field"
                      @click="deleteFields(index, index2)"
                      v-if="index2 > 0"
                      ><b-icon icon="delete" type="is-danger"></b-icon
                    ></a>
                  </b-field>
                </div>
              </b-field>
              <b-field class="columns column add-field"
                ><a type="is-primary" @click="addFields(index)"
                  >+&nbsp;Add Field</a
                ></b-field
              >
            </div>
            <hr />
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Cancel"
            class="is-normal"
            @click="dataCompletionCancel"
          />
          <b-button slot="right" type="is-primary" native-type="submit">
            Apply
          </b-button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import DataManagementService from "../../services/DataManagementImportService";
import ErrorMixin from "@/mixins/ErrorMixin";
import ProductMixin from "@/mixins/ProductMixin";
import UtilityMixin from "@/mixins/UtilityMixin";
import { CDFStream } from "../../constants/CDFStream";
import { DataCompletionOperations } from "../../constants/DataCompletionOperations";
export default {
  name: "DataCompletion",
  //components: { Multiselect },
  mixins: [ErrorMixin, ProductMixin, UtilityMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },

    customerId: {
      type: Number,
      default: -1
    },

    columns: {
      type: Array
    },
    columnsConfig: {
      type: Array
    },

    checkedRows: {
      type: Array
    },

    isCheckedAllRows: {
      type: Boolean
    },
    stream: {
      type: String
    },
    tempProduct: {
      type: Boolean
    },
    query: {
      type: String
    }
  },
  data() {
    return {
      streams: [
        {
          value: null,
          fields: [
            {
              field_name: null,
              operation: null,
              value: null,
              field_type: null,
              dropdown_value: null
            }
          ]
        }
      ],
      streamsDropdown: this.prepareDropDownArray(CDFStream),
      operations: this.prepareDropDownArray(DataCompletionOperations),
      isDependentField: false,
      isModalActive: false,
      isReloaded: false,
      index: 0,
      dependentIndex: 0,
      dependentField: null,
      form: {},
      cdf_product_sheet: [],
      DataManagementService: new DataManagementService()
    };
  },
  methods: {
    getStreamFields(streamValue) {
      return this.cdf_product_sheet?.[streamValue] || [];
    },
    getSelectedFieldConfig(columnName, streamValue) {
      const streamFields = this.getStreamFields(streamValue);
      if (!streamFields.length || !columnName) {
        return null;
      }
      return (
        streamFields.find(
          col =>
            col.product_data_column &&
            col.product_data_column.trim() === columnName.trim()
        ) || null
      );
    },
    getDropdownFieldValues(columnName, streamValue) {
      const fieldConfig = this.getSelectedFieldConfig(columnName, streamValue);
      return fieldConfig?.dropdown_field_values || [];
    },
    isDateField(columnName, streamValue) {
      const fieldConfig = this.getSelectedFieldConfig(columnName, streamValue);
      return fieldConfig ? fieldConfig.field_type === "Date" : false;
    },
    isDropdownField(columnName, streamValue) {
      const fieldConfig = this.getSelectedFieldConfig(columnName, streamValue);
      return fieldConfig ? fieldConfig.field_type === "Dropdown" : false;
    },
    addFieldType(val, index, index2) {
      const temp = this.getStreamFields(this.streams[index].value).filter(
        i => i.product_data_column == val
      );
      this.streams[index].fields[index2]["field_type"] = temp[0]
        ? temp[0]["field_type"]
        : null;
    },
    checkStream(val, index) {
      let isSelected = false;
      this.streams.forEach((obj, i) => {
        if (obj.value == val && index != i) {
          isSelected = true;
        }
      });
      if (isSelected) {
        this.$buefy.dialog.alert({
          title: "Warning",
          message:
            "This Stream has already been choosen earlier. Please choose another stream.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true,
          onConfirm: () => this.updateStream(index)
        });
      }
    },
    updateStream(index) {
      this.streams[index].value = null;
    },
    addStream() {
      this.streams.push({
        value: null,
        fields: [
          {
            field_name: null,
            operation: null,
            value: null,
            field_type: null
          }
        ]
      });
    },
    deleteStream(index) {
      this.streams.splice(index, 1);
    },
    deleteFields(index, index2) {
      this.streams[index].fields.splice(index2, 1);
    },
    addFields(index) {
      this.streams[index].fields.push({
        field_name: null,
        operation: null,
        value: null,
        field_type: null
      });
    },
    prepareDropDownArray(value) {
      const result = [];
      Object.keys(value).forEach(element => {
        const obj = {};
        obj["name"] = element;
        result.push(obj);
      });
      return result;
    },

    find_column_config_indexs(column_name, streamValue) {
      if (this.cdf_product_sheet && this.cdf_product_sheet[streamValue]) {
        return this.cdf_product_sheet[streamValue].findIndex(
          col => col.product_data_column.trim() === column_name.trim()
        );
      }
    },
    dataCompletionCancel() {
      this.isModalActive = false;
    },

    updateData() {
      const checkedData = this.isCheckedAllRows
        ? this.isCheckedAllRows
        : this.checkedRows;
      this.DataManagementService.dataCompletion(
        this.$route.params.id,
        this.tempProduct,
        this.streams,
        this.stream,
        checkedData,
        this.query,
        this.customerId
      ).subscribe(() => {
        this.$buefy.dialog.alert({
          title: "Data Completion Successful",
          message:
            "Please note: Not all your changes might be applied right away as this process can take some time to complete.",
          ariaRole: "alertdialog",
          ariaModal: true,
          onConfirm: () => {
            // Only trigger reload and close modal after the user clicks OK
            this.$emit("reload");
            this.isModalActive = false;
            this.isReloaded = true;
          }
        });
      }, this.handleApiError);
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.streams = [
          {
            value: null,
            fields: [
              {
                field_name: null,
                operation: null,
                value: null,
                field_type: null
              }
            ]
          }
        ];
        if (this.isReloaded) {
          this.$emit("cancel", "reload");
        } else {
          this.$emit("cancel");
        }
      }
    },
    columnsConfig(newValue) {
      const cdf_columns = newValue[0] ? newValue[0]["template_fields"] : "";
      if (cdf_columns) {
        this.cdf_product_sheet[CDFStream.BATT] = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BATT
        );

        this.cdf_product_sheet[CDFStream.PACK] = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PACK
        );

        this.cdf_product_sheet[CDFStream.WEEE] = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.WEEE
        );

        this.cdf_product_sheet["BUNDLE"] = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BUNDLE
        );

        this.cdf_product_sheet["PRODUCT_SHEET"] = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PRODUCT_SHEET
        );
      }
    }
  }
};
</script>
